import { useEffect } from "react";
import { useBlocker } from "react-router";

// Blocks in-app navigation and browser unload while the form reports unsaved edits.
export const useUnsavedChangesGuard = (isDirtyRef) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirtyRef.current && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!isDirtyRef.current) return;
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirtyRef]);

  return blocker;
};
